var scope_0 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7df39193d46f713fd1e15b7bc0ee5ff5.js').default;
var scope_1 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8d62a6ce52454b1ddf1379df9a0fc32b.js').default;
var scope_2 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    